export default "__VITE_PUBLIC_ASSET__ae405eaa__"